import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { type Center } from '@avanta/shared/types/appointments';

export const useFetchCenters = (specialityId: string | number): UseQueryResult<Center[], Error> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_CENTERS, specialityId],
    queryFn: () => AppointmentService.getCenters(specialityId),
    select: response => response.data,
    enabled: Boolean(specialityId),
    staleTime: FIFTEEN_MINUTES,
  });
